import { render, staticRenderFns } from "./msgCenter.vue?vue&type=template&id=6b727a14&scoped=true&"
import script from "./msgCenter.vue?vue&type=script&lang=js&"
export * from "./msgCenter.vue?vue&type=script&lang=js&"
import style0 from "./msgCenter.vue?vue&type=style&index=0&id=6b727a14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b727a14",
  null
  
)

export default component.exports